const TRACE_ENABLED =
	process.env.REACT_APP_TRACE_FLOWS !== "false" && process.env.REACT_APP_TRACE_FLOWS !== "0";

const API_BASES = [process.env.REACT_APP_ESSILOR_API, process.env.REACT_APP_LABS_API].filter(Boolean);

const flowStack = [];
let originalFetch = null;

function shouldTrace(url) {
	if (!url || typeof url !== "string") {
		return false;
	}
	if (API_BASES.some(base => url.indexOf(base) === 0)) {
		return true;
	}
	return url.charAt(0) === "/";
}

function installFetchInterceptor() {
	if (originalFetch || typeof window === "undefined" || typeof window.fetch !== "function") {
		return;
	}

	originalFetch = window.fetch.bind(window);

	window.fetch = (input, init) => {
		try {
			const context = flowStack[flowStack.length - 1];

			if (context && typeof input === "string" && shouldTrace(input)) {
				context.count += 1;

				console.log(`[trace:${context.flow}]`, {
					seq: context.count,
					method: ((init && init.method) || "GET").toUpperCase(),
					url: input,
				});
			}
		} catch (error) {
			return originalFetch(input, init);
		}

		return originalFetch(input, init);
	};
}

function restoreFetchInterceptor() {
	if (originalFetch && typeof window !== "undefined") {
		window.fetch = originalFetch;
		originalFetch = null;
	}
}

export function startFlowTrace(flow) {
	if (!TRACE_ENABLED || !flow) {
		return null;
	}

	const context = {
		flow,
		count: 0,
	};

	flowStack.push(context);
	installFetchInterceptor();

	return flow;
}

export function stopFlowTrace(flow) {
	if (!TRACE_ENABLED || !flow) {
		return;
	}

	for (let index = flowStack.length - 1; index >= 0; index -= 1) {
		if (flowStack[index].flow === flow) {
			flowStack.splice(index, 1);
			break;
		}
	}

	if (flowStack.length === 0) {
		restoreFetchInterceptor();
	}
}
